var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "social-date-picker" }, [
    _c("fieldset", { staticClass: "date-time" }, [
      _c(
        "div",
        { staticClass: "date" },
        [
          _c("vuejs-datepicker", {
            attrs: {
              placeholder: "No Date",
              highlighted: _vm.highlightedDates,
              format: _vm.displayPostDate
            },
            on: { closed: _vm.dateTimeUpdated },
            model: {
              value: _vm.postDate,
              callback: function($$v) {
                _vm.postDate = $$v
              },
              expression: "postDate"
            }
          }),
          _vm._v(" "),
          _vm.isDateDuplicate
            ? _c("i", {
                staticClass: "fas fa-exclamation-circle date-duplicate-icon",
                attrs: { id: _vm.duplicateDateTooltipId }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isDateDuplicate
            ? _c(
                "b-tooltip",
                {
                  attrs: {
                    target: _vm.duplicateDateTooltipId,
                    triggers: "hover"
                  }
                },
                [
                  _vm._v(
                    "\n        This date has multiple posts scheduled\n      "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "time" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.postTime,
              expression: "postTime"
            }
          ],
          attrs: {
            type: "time",
            id: _vm.timePickerId,
            name: "appt",
            disabled: _vm.dateTimeDisabled
          },
          domProps: { value: _vm.postTime },
          on: {
            blur: _vm.dateTimeUpdated,
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.postTime = $event.target.value
            }
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }